module.exports = __webpack_public_path__ + "79c205f0.svg";